var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUpload(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "#000000",
    height: "800px",
    width: "800px",
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 211.293 211.293",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M176.777,54.027H133.43c-4.142,0-7.5,3.357-7.5,7.5c0,4.142,3.358,7.5,7.5,7.5h35.847v127.266H42.016V69.027H77.86 c4.142,0,7.5-3.357,7.5-7.5c0-4.143-3.358-7.5-7.5-7.5H34.516c-4.142,0-7.5,3.357-7.5,7.5v142.266c0,4.143,3.358,7.5,7.5,7.5 h142.261c4.142,0,7.5-3.357,7.5-7.5V61.527C184.277,57.385,180.919,54.027,176.777,54.027z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.058,41.693l16.087-16.087V135.66c0,4.143,3.358,7.5,7.5,7.5c4.143,0,7.5-3.357,7.5-7.5V25.607l16.086,16.086 c1.464,1.465,3.384,2.197,5.303,2.197c1.919,0,3.838-0.733,5.303-2.196c2.929-2.93,2.929-7.678,0-10.607l-28.889-28.89 C109.542,0.79,107.634,0,105.645,0c-1.988,0-3.896,0.79-5.303,2.196l-28.891,28.89c-2.929,2.929-2.929,7.678,0,10.606 C74.38,44.622,79.129,44.621,82.058,41.693z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpload);
export default __webpack_public_path__ + "static/media/upload.d52d96ca1793725638ede6530b49f86a.svg";
export { ForwardRef as ReactComponent };